export const APP_READY = 'APP_READY';
export const APP_UPDATED = 'APP_UPDATED';
export const DATE_FETCHED = 'DATE_FETCHED';
export const GALLERY_IMAGES_FETCHED = 'GALLERY_IMAGES_FETCHED';
export const GALLERY_VIDEOS_FETCHED = 'GALLERY_VIDEOS_FETCHED';
export const LOAD_COMPLETE = 'LOAD_COMPLETE';
export const POPULATE_TRAVEL_DATES = 'POPULATE_TRAVEL_DATES';
export const RESET_ACTIVE_DATE = 'RESET_ACTIVE_DATE';
export const SELECT_DATE = 'SELECT_DATE';
export const TOGGLE_MENU = 'TOGGLE_MENU';
export const TRIP_FETCHED = 'TRIP_FETCHED';
